const scrollTop = ()=>{
    if ("u" > typeof window) window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
};
export { scrollTop };
